import React from 'react';

export interface IDataContext {
  providerId: number;
}

const DataContext = React.createContext<IDataContext>({ providerId: 0 });

export const DataContextProvider = DataContext.Provider;

export const DataContextConsumer = DataContext.Consumer;

export const withDataContext =
  (Component: React.ComponentType<any>) => (props: any) => (
    <DataContextConsumer>
      {(dataContext: IDataContext) => (
        <Component {...props} dataContext={dataContext} />
      )}
    </DataContextConsumer>
  );
